// src/pages/NotFound.js
import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-4">
      <div className="text-center max-w-md">
        <h1 className="text-4xl font-bold text-green mb-6">Non ho trovato questa pagina</h1>
        <img 
          src="/icons/favicon.svg" 
          alt="404 Icon" 
          className="w-32 h-32 mx-auto mb-6 opacity-70"
        />
        <p className="text-lg text-gray-600 mb-8">
          Forse il contenuto che stai cercando è stato spoostato o romosso
        </p>
        <Link 
          to="/" 
          className="inline-block bg-green hover:bg-accent text-white font-medium py-3 px-6 rounded-lg transition duration-300"
        >
          Ritorna alla home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;